"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementContainsDomRect = void 0;
exports.elementContainsDomRect = function (rect) { return function (region) {
    var regionRect = region.getBoundingClientRect();
    var horizontalMatch = regionRect.x <= rect.x && rect.x <= regionRect.x + regionRect.width;
    var verticalMatch = regionRect.y <= rect.y && rect.y <= regionRect.y + regionRect.height;
    return horizontalMatch && verticalMatch;
}; };
//# sourceMappingURL=elementContainsDomRect.js.map